import React, { useEffect } from 'react';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import getEnvironmentTheme from './environmentTheme';

const EnvironmentThemeProvider = ({ children }) => {
  const theme = getEnvironmentTheme();

  useEffect(() => {
    // Apply CSS variables to root element
    const root = document.documentElement;
    
    // Set environment-specific CSS variables
    root.style.setProperty('--jmi-blue', theme.primary);
    root.style.setProperty('--jmi-blue-hover', theme.primaryHover);
    root.style.setProperty('--jmi-blue-dark', theme.primaryDark);
    root.style.setProperty('--jmi-blue-light', theme.primaryLight);
    root.style.setProperty('--jmi-green', theme.secondary);
    root.style.setProperty('--jmi-red', theme.accent);
    root.style.setProperty('--jmi-red-hover', theme.accentHover);
    root.style.setProperty('--jmi-red-raw', theme.accentRaw);
    
    // Add environment indicator to document title
    const originalTitle = document.title;
    if (!theme.isProduction) {
      document.title = `[${theme.environment}] ${originalTitle}`;
    }
    
    // Add environment indicator to body class
    document.body.classList.add(`env-${theme.environment.toLowerCase()}`);
    
    // Cleanup function
    return () => {
      document.title = originalTitle;
      document.body.classList.remove(`env-${theme.environment.toLowerCase()}`);
    };
  }, [theme]);

  // Create Material-UI theme
  const muiTheme = createMuiTheme({
    palette: {
      primary: {
        main: theme.primary,
        dark: theme.primaryDark,
        light: theme.primaryLight,
      },
      secondary: {
        main: theme.secondary,
      },
      error: {
        main: theme.accent,
      },
    },
    overrides: {
      MuiAppBar: {
        colorPrimary: {
          backgroundColor: theme.primary,
        },
      },
      MuiButton: {
        containedPrimary: {
          backgroundColor: theme.primary,
          '&:hover': {
            backgroundColor: theme.primaryHover,
          },
        },
        containedSecondary: {
          backgroundColor: theme.secondary,
        },
      },
      MuiSwitch: {
        track: {
          backgroundColor: theme.primaryDark,
        },
      },
    },
  });

  return (
    <ThemeProvider theme={muiTheme}>
      {children}
    </ThemeProvider>
  );
};

export default EnvironmentThemeProvider; 